angular
    .module('dnecom.component.cart')
    .service('CartHash', ["$cookies", function ($cookies) {
        var COOKIE_KEY = 'cartHash';
        var COOKIE_KEY_PREVIOUS_CART = 'cartHashPrevious';

        var fromMeta = function () {
            try {
                return document.querySelector("meta[name='cart-hash']").getAttribute('content');
            } catch (err) {}
        };

        var isForcedFromMeta = function () {
            try {
                return document.querySelector("meta[name='cart-hash-forced']").getAttribute('content');
            } catch (err) {}
        };

        return {
            get: function () {
                var hash = fromMeta();

                if (hash) {
                    if (isForcedFromMeta() && $cookies.get(COOKIE_KEY)) {
                        $cookies.put(COOKIE_KEY_PREVIOUS_CART, $cookies.get(COOKIE_KEY), {
                            path: '/',
                            expires: new Date(new Date().getTime() + (60 * 60 * 24 * 1000))
                        })
                    }
                    this.set(hash);
                } else {
                    if ($cookies.get(COOKIE_KEY_PREVIOUS_CART)) {
                        this.set($cookies.get(COOKIE_KEY_PREVIOUS_CART));
                        $cookies.remove(COOKIE_KEY_PREVIOUS_CART, { path: '/'});
                    }
                }

                return $cookies.get(COOKIE_KEY);
            },

            set: function (hash) {
                $cookies.put(COOKIE_KEY, hash, {
                    path: '/',
                    expires: new Date(new Date().getTime() + (60 * 60 * 24 * 1000))
                });
            },

            unset: function () {
                $cookies.remove(COOKIE_KEY, { path: '/'});
            }
        }
    }]);
